module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/logo.png
// module id = 1220
// module chunks = 0